import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';

import PageHeader from '../PageHeader';
import FeedTable from '../../containers/table/feed/FeedTable';
import PeriodFilter from '../../components/filter/PeriodFilter';

class FundsPage extends Component {
    static propTypes = {
        // Props
        title: PropTypes.string.isRequired,
        filters: PropTypes.object.isRequired,
        symbols: PropTypes.array.isRequired,
        isFetching: PropTypes.bool.isRequired,
        t: PropTypes.func.isRequired,

        // Dispatch
        changePage: PropTypes.func.isRequired,
        changeFilters: PropTypes.func.isRequired,
        loadingFunds: PropTypes.func.isRequired,
    };

    render() {
        const { filters, isFetching, symbols, changeFilters, loadingFunds, t } = this.props;

        const periodTabs = [
            [t('day'), 'DAY'],
            [t('week'), '1WEEK'],
            [t('month'), '1M'],
            [t('halfYear'), '6M'],
            [t('year'), 'GAVG1YR'],
            [t('yearWithCount', { count: 3 }), 'GAVG3YR'],
            [t('yearWithCount', { count: 5 }), 'GAVG5YR'],
            [t('yearWithCount', { count: 10 }), 'GAVG10YR'],
        ];

        return (
            <div>
                <PageHeader title={this.props.title} />
                <PeriodFilter
                    changeFilters={changeFilters}
                    tabs={periodTabs}
                    period={filters.period}
                />
                <FeedTable
                    symbols={symbols}
                    filters={filters}
                    changeFilters={changeFilters}
                    loading={loadingFunds}
                    isFetching={isFetching}
                    funds
                />
            </div>
        );
    }
}

export default translate('date')(FundsPage);



/** WEBPACK FOOTER **
 ** /src/shared/components/pages/FundsPage.js
 **/